export default __webpack_public_path__ + "static/media/analyst.f71759ae.png";